import { render, staticRenderFns } from "./AsthmaFormNode.vue?vue&type=template&id=fd28323e&"
import script from "./AsthmaFormNode.vue?vue&type=script&lang=js&"
export * from "./AsthmaFormNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports